module.exports = __webpack_public_path__ + "teqbahn-assets/media/Color_tiles.a46d10f1.jpg";